class n {
  constructor() {
  }
  validate(t) {
    const r = (/* @__PURE__ */ new Date()).getFullYear() - 18, e = String(t);
    return /^\d{4}$/.test(e) ? !(t < 1900 || t > r) : !1;
  }
}
export {
  n as default
};
